import Agathis1 from "../Summarecon Bogor/Agathis.webp"
import Agathis2 from "../Summarecon Bogor/Agathis.webp"

const Agathisimages =[
    Agathis1,Agathis2
]

export default Agathisimages;